export const CREDENTIALS = {
  appId: 77285,
  authKey: "DgxjCtv3JV6v7Yd",
  authSecret: "gEsZKKNW2unr9ZH"
};
